import React, {Component} from "react";
import { observer } from "mobx-react";
import {Link} from "react-router-dom";

@observer
class NoticeDetailListView extends Component {

    render() {

        const { rootStore } = this.props;
        let detail = rootStore.settingStore.getNoticeDetailList;
        
        return (
            <div className="section_content notice">
                <h3>상세 내용</h3>
                <div className="scroll notice" id="notiScroll">
                {(detail.length != 0 )?
                    <>
                    <div className="inner">
                        <div className="wrap_notice">
                            <h4>
                                <span className={detail.detailType === "N" ? "gray" : detail.detailType === "I" ? "blue" : "red"}>
                                    {detail.detailType === "N" ? "공지" : detail.detailType === "I" ? "안내" : "긴급"}
                                </span>
                                {detail.title}
                            </h4>
                            <p className="date">{detail.insDt}</p>
                            <div className="detail" dangerouslySetInnerHTML={ {__html: detail.content} }></div>
                        
                        </div>
                    </div>
                    </>:<div className="null"><span></span>등록된 공지글이 없습니다</div>
                    } 
                    <div className="close">
                        <Link to="/"><button type="button"><span>페이지 닫기</span></button></Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoticeDetailListView;